var map = {
	"./chicago-1.jpg": 9307,
	"./chicago-2.jpg": 1612,
	"./magic-man.jpg": 4507,
	"./moon-1.jpg": 1296,
	"./pier_at_night.jpg": 3942,
	"./pike_at_night.jpg": 9333,
	"./taiwan-3.jpg": 6993,
	"./tuition-1971.jpg": 5218,
	"./tuition-2021.jpg": 9417,
	"./work-1.jpg": 6232,
	"./work-2.jpg": 7159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2577;